import React from "react";
import useOnClickOutside from "../../hooks/useOutsideClick";

const DropdownMenu = ({
  children,
  onClose,
  containerRef,
}: {
  children: React.ReactNode;
  onClose?: () => void;
  containerRef: React.RefObject<HTMLDivElement | null>;
}) => {
  useOnClickOutside(containerRef, () => {
    onClose && onClose();
  });
  return (
    <div className="bc-bg-white bc-box-border bc-border-solid bc-bottom-0 bc-shadow-[0_3px_15px_0px_rgba(195,188,188,0.15)] bc-border bc-border-[#dcdddc80] bc-rounded-[8px]">
      {children}
    </div>
  );
};

export default DropdownMenu;
